import { storageAvailable } from "./localStorage";

// Define the type of the fallback storage using an object with string keys and values of unknown type.
type MemoryStorage = Record<string, unknown>;

const memoryStorageFallback: MemoryStorage = {};

export function getItem<T>(key: string): T | null {
	if (storageAvailable("sessionStorage")) {
		try {
			const item = window.sessionStorage.getItem(key);
			return item ? (JSON.parse(item) as T) : null;
		} catch {
			return null;
		}
	}

	return memoryStorageFallback[key] as T | null;
}

export function setItem<T>(key: string, value: T): void {
	if (storageAvailable("sessionStorage")) {
		window.sessionStorage.setItem(key, JSON.stringify(value));
	} else {
		memoryStorageFallback[key] = value;
	}
}

export function removeItem(key: string): void {
	if (storageAvailable("sessionStorage")) {
		window.sessionStorage.removeItem(key);
	} else {
		delete memoryStorageFallback[key];
	}
}
